import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Label } from 'core/components/label';
import AddButton from 'core/components/add-button';
import RemoveButton from 'core/components/remove-button';
import greenCheckIcon from 'core/assets/svg/green-check.svg';
import useStyles from './discount-row.styles';

/**
 * One discount row on the policy Discounts card (#32231). A store-independent analog of the
 * offer-side `Discount` row: it shows the discount label and the same add/remove affordance, but
 * binds to nothing itself — the parent `FarmDiscounts` supplies `onAdd`/`onRemove`.
 *
 * Affordance (mirrors the offer row):
 *   - active + editable   → Remove button
 *   - active + read-only  → green check (applied, can't change — e.g. claim-free for a non-UW)
 *   - inactive + editable → Add button
 *   - inactive + read-only → label only
 */
const DiscountRow = ({ id, label, isActive, onAdd, onRemove, disabled }) => {
  const classes = useStyles();
  return (
    <div id={id} className={classNames(classes.row, { [classes.inactive]: !isActive })}>
      <div className={classes.labelSection}>
        <Label type="discount">{label}</Label>
      </div>
      <div className={classes.section}>
        {isActive && !onRemove && <img src={greenCheckIcon} alt="applied" />}
        {isActive && onRemove && <RemoveButton onClick={onRemove} disabled={disabled} />}
        {!isActive && onAdd && (
          <AddButton type="full" className={classes.addButton} onClick={onAdd} disabled={disabled} />
        )}
      </div>
    </div>
  );
};

DiscountRow.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  disabled: PropTypes.bool
};

DiscountRow.defaultProps = {
  isActive: false,
  onAdd: undefined,
  onRemove: undefined,
  disabled: false
};

export default DiscountRow;
